import { ContentRendererContainer } from "./ContentRendererContainer";
import { ContentRendererBody } from "./ContentRendererBody";
import { LandingZigZag } from "../LandingZigZag/LandingZigZag";
import { CommonContainerPropsComponent } from "../../../api/content-client/service";

interface Props {
  body?: any;
  containerProps?: CommonContainerPropsComponent;
  isCentered?: boolean;
  media?: any;
  media2?: any;
  title?: string;
  variant?: 'left' | 'right' | null;
}

export function ContentRendererZigZag(block: Props) {
  const {
    containerProps,
    body,
    isCentered,
    media,
    media2,
    title,
    variant
  } = block || {};

  return (
    <ContentRendererContainer containerProps={containerProps}>
      <LandingZigZag
        image1={media?.data?.attributes?.url}
        image2={media2?.data?.attributes?.url}
        image2Alt={media2?.data?.attributes?.alternativeText}
        image2Height={media2?.data?.attributes?.height}
        image2Width={media2?.data?.attributes?.width}
        isCentered={isCentered}
        title={title}
        variant={variant || 'left'}
      >
        <ContentRendererBody
          body={body}
          paragraphVariant="bodyLg"
        />
      </LandingZigZag>
    </ContentRendererContainer>
  )
}
